const iconNames = {
  '⌄': 'chevron-down',
  '⌕': 'search',
  '♙': 'user',
  '♡': 'heart',
  '♥': 'heart',
  '▱': 'cart',
  '☼': 'sun',
  '◐': 'moon',
  '☰': 'menu',
  '×': 'close',
  '⌂': 'home',
  '▦': 'grid',
  '▤': 'credit-card',
  '◷': 'clock',
  '₾': 'coins',
  '↗': 'arrow-up-right',
  '→': 'arrow-right',
  '＋': 'plus',
  '+': 'plus',
  '›': 'chevron-right',
  '‹': 'chevron-left',
  bag: 'shopping-bag',
  trash: 'trash',
  check: 'check',
};

const iconPaths = {
  'chevron-down': <path d="m6 9 6 6 6-6" />,
  'chevron-right': <path d="m9 18 6-6-6-6" />,
  'chevron-left': <path d="m15 18-6-6 6-6" />,
  search: <><circle cx="11" cy="11" r="7" /><path d="m20 20-4-4" /></>,
  user: <><circle cx="12" cy="8" r="4" /><path d="M5 21a7 7 0 0 1 14 0" /></>,
  heart: <path d="M20.8 8.8c0 4.1-8.8 10-8.8 10s-8.8-5.9-8.8-10a4.7 4.7 0 0 1 8.8-2.2 4.7 4.7 0 0 1 8.8 2.2Z" />,
  cart: <><path d="M3 4h2l2.3 11.1a2 2 0 0 0 2 1.6h8.8a2 2 0 0 0 2-1.6L22 8H6" /><circle cx="10" cy="20" r="1" /><circle cx="18" cy="20" r="1" /></>,
  sun: <><circle cx="12" cy="12" r="4" /><path d="M12 2v2m0 16v2M4.93 4.93l1.42 1.42m11.3 11.3 1.42 1.42M2 12h2m16 0h2M4.93 19.07l1.42-1.42m11.3-11.3 1.42-1.42" /></>,
  moon: <path d="M20.5 14.5A8.5 8.5 0 0 1 9.5 3.5 8.5 8.5 0 1 0 20.5 14.5Z" />,
  menu: <><path d="M4 6h16M4 12h16M4 18h16" /></>,
  close: <><path d="m18 6-12 12M6 6l12 12" /></>,
  home: <><path d="m3 10 9-7 9 7" /><path d="M5 9v12h14V9M9 21v-7h6v7" /></>,
  grid: <><rect x="3" y="3" width="8" height="8" rx="1" /><rect x="13" y="3" width="8" height="8" rx="1" /><rect x="3" y="13" width="8" height="8" rx="1" /><rect x="13" y="13" width="8" height="8" rx="1" /></>,
  'credit-card': <><rect x="3" y="5" width="18" height="14" rx="2" /><path d="M3 10h18" /><path d="M7 15h3" /></>,
  clock: <><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></>,
  coins: <><circle cx="8" cy="8" r="5" /><path d="M8 5v6m-2-4h4m-4 2h4" /><path d="M13 7.5a5 5 0 1 1-3.5 9" /><path d="M15 13v6m-2-4h4m-4 2h4" /></>,
  'arrow-up-right': <><path d="M7 17 17 7M7 7h10v10" /></>,
  'arrow-right': <><path d="M5 12h14" /><path d="m13 6 6 6-6 6" /></>,
  plus: <><path d="M12 5v14M5 12h14" /></>,
  'shopping-bag': <><path d="M5 8h14l1 13H4L5 8Z" /><path d="M9 9V6a3 3 0 0 1 6 0v3" /></>,
  trash: <><path d="M4 7h16" /><path d="M10 11v6m4-6v6" /><path d="m5 7 1 14h12l1-14M9 7V4h6v3" /></>,
  check: <path d="m5 12 4 4L19 6" />,
  spark: <><path d="m12 3 1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8L12 3Z" /><path d="m19 16 .8 2.2L22 19l-2.2.8L19 22l-.8-2.2L16 19l2.2-.8L19 16Z" /></>,
};

export const Icon = ({ children, className = '' }) => {
  const name = iconNames[String(children)] || 'spark';
  return (
    <span aria-hidden="true" className={`icon ${className}`}>
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
        {iconPaths[name]}
      </svg>
    </span>
  );
};
